<div class="container">
    <div class="row justify-content-center pt-5">
        <div class="col-sm-10">
            <p>
                This Privacy Notice (hereinafter: „Notice“) describe how Beyondi
                (hereinafter: Beyondi or “we”, “our” or “us”) will manage end
                user's personal data which we collect as a result of your use of
                websites located at www.example.page and any pages or websites
                under the 'Beyondi' brand or whenever we otherwise deal with a
                data subject (hereinafter: “you”). Beyondi commits to collect
                and process personal data as described in this Notice and in
                accordance with the applicable data protection laws. Our website
                is governed in accordance by the General Data Protection
                Regulation (the “GDPR”), (Regulation (EU) 2016/679) and the
                terms used in this Notice have the meaning ascribed to it in the
                GDPR. Beyondi is considered the data controller and will
                determine the purposes and means of the processing of personal
                data submitted and collected online as per this Notice. By
                visiting Beyondi website, otherwise communicating with us or
                using the LitBit services you agree to be bound by the terms of
                this Notice. This Notice will not apply to websites which are
                linked to the website and over which Beyondi has no control
                (e.g. Facebook plug in, Instagram plug in, Twiiter plug in,
                etc.). For further information regarding the use of data by
                those websites/apps, please refer to their privacy related
                notices.
            </p>
        </div>
    </div>
    <div class="row justify-content-center pt-5">
        <div class="col-sm-10">
            <h3>PRINCIPLES</h3>
            <p>
                This Notice is based on the following data protection
                principles:
            </p>
            <ul class="termsList">
                <li>
                    The processing of personal data shall take place in a
                    lawful, fair and transparent way;
                </li>
                <li>
                    The collecting of personal data shall only be performed for
                    specified, explicit and legitimate purposes and not further
                    processed in a manner that is incompatible with those
                    purposes;
                </li>
                <li>
                    The collecting of personal data shall be adequate, relevant
                    and limited to what is necessary in relation to the purpose
                    for which they are processed;
                </li>
                <li>
                    The personal data shall be accurate and where necessary,
                    kept up to date;
                </li>
                <li>
                    Every reasonable step shall be taken to ensure that personal
                    data that are inaccurate having regard to the purposes for
                    which they are processed, are erased or rectified without
                    delay;
                </li>
                <li>
                    Personal data shall be kept in a form which permits
                    identification of the data subject for no longer than it is
                    necessary for the purpose for which the personal data are
                    processed;
                </li>
                <li>
                    All personal data shall be kept confidential and stored in a
                    manner that ensures appropriate security;
                </li>
                <li>
                    Personal data shall not be shared with third parties except
                    when necessary in order for them to provide services;
                </li>
                <li>
                    Data subjects shall have the right to request access to and
                    rectification or erasure of personal data, or restriction of
                    processing, or to object to processing as well as the right
                    of data portability.
                </li>
            </ul>
        </div>
    </div>

    <div class="row justify-content-center pt-5">
        <div class="col-sm-10">
            <h3>PROCESSING ACTIVITIES</h3>
            <p>
                Beyondi may collect following personal data: Name and surname,
                Email, Wallet address (and related transaction details) and
                other personal data submitted by you. Personal data would be
                processed only for the purpose for which it has been collected
                and under lawful basis to provide you with our services or to
                provide you with the information you have requested from us as
                it follows:
            </p>
            <ul class="termsList">
                <li>
                    To send you our marketing communication or newsletter in
                    case you subscribe to our newsletter list;
                </li>
                <li>To respond to your request submitted to us;</li>
                <li>To provide Beyondi service or to whitelist you;</li>
                <li>
                    To comply with Beyondi's legal and statutory obligation;
                </li>
                <li>
                    To take adequate actions in case of suspected unlawful
                    activity or misconduct related to our services;
                </li>
                <li>To establish, exercise or defend any legal claims.</li>
            </ul>
            <p>
                All the personal data collected via Litbit website or any of our
                official channels of communication is collected directly from
                you. When organising events via our partners communication
                channels to provide whitelisted spots your personal data would
                be provided to us by our partner but only under conditions that
                you decide to participate in the event and to share personal
                data necessary to provide services (whitelisted spot) to you.
                When personal data if processed based on your consent (e.g.
                subscription at newsletter) you may withdraw your consent at any
                time by contacting us at email info@beyondi.co.
            </p>
        </div>
    </div>

    <div class="row justify-content-center pt-5 py-5 mb-5">
        <div class="col-sm-10">
            <h3>TRANFER OF DATA TO THIRD PARTIES AND THIRD COUNTRIES</h3>
            <p>
                Occasionally we may engage service providers to work on our
                behalf, such as but not limited to, cloud provider company,
                company providing technical support or advisory or other company
                to provide part of our services. In case we are engaging
                services providers to act on our behalf we would share only
                necessary personal data needed to provide their services. Your
                personal data can be processed only to the extent needed to
                provide the services in question and would never be used for
                their own purposes (e.g. to market their products and services
                to you). In certain situations, Beyondi may be required to
                disclose personal data in response to lawful requests by
                supervisory authorities to meet the requirements of the
                applicable law. We may also disclose personal data if required
                by law, such as to comply with a subpoena or other legal
                processes, when we believe in good faith that disclosure is
                necessary to protect our rights, protect customer safety or the
                safety of others, investigate fraud, or to respond to a
                government request. In case of merger, restructuring or sale
                (parts or entire) Beyondi's assets or due to bankruptcy,
                liquidation or similar proceeding personal data may be shared or
                transferred. Personal data processed under this Notice is stored
                in the data center located in the EU and in case of transfer to
                third countries, Beyondi would put in place appropriate
                measures, including, if applicable, Standard Contractual
                Clauses, to ensure personal data is transferred in accordance
                with the applicable data protection laws.
            </p>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-sm-10">
            <h3>RETENTION</h3>
            <p>
                Beyondi will use personal data for the purpose it is collected
                and keep the data only for as long as it is necessary for that
                purpose and to comply with our legal obligations.
            </p>
        </div>
    </div>

    <div class="row justify-content-center pt-5">
        <div class="col-sm-10">
            <h3>SECURITY</h3>
            <p>
                We will take all the reasonable steps to process personal data
                securely, apply and maintain appropriate technical and
                organizational measures to protect personal data against
                accidental or unlawful destruction or accidental loss,
                alteration, unauthorized disclosure, or access, in particular
                where the processing involves the transmission of data over a
                network. Nevertheless, no transmition over the Internet is
                totally secure and Beyondi does not warrant the complete
                security of any information you may transmit to us and
                therefore, you acknowledge that transmition in overtaken on your
                own risk. Measures taken by Beyondi to protect your information
                are applicable when we receive your data.
            </p>
        </div>
    </div>

    <div class="row justify-content-center pt-5">
        <div class="col-sm-10">
            <h3>DATA SUBJECT RIGHTS</h3>
            <p>
                Where permissible under applicable dana protection law you may
                have the following rights:
            </p>
            <ul class="termsList">
                <li>Request the access to your personal data;</li>
                <li>
                    Request rectification of inaccurate or incomplete personal
                    data;
                </li>
                <li>
                    Request deletion of your personal data in some
                    circumstances;
                </li>
                <li>
                    Request restriction of processing in certain circumstances;
                </li>
                <li>
                    Object to the processing of your personal data in certain
                    circumstances;
                </li>
                <li>
                    Request that we transfer the personal data you gave us to
                    another organisation, or to you, in certain circumstances;
                </li>
                <li>
                    Withdraw your consent to processing of your personal data
                    (to the extent processing is based on consent).
                </li>
            </ul>
            <p>
                You may contact us at any time with your request as per
                applicable dana protection law and under limits specified in the
                law at email info@beyondi.co. We will respond to your request in
                reasonable time, within the deadlines set out in the applicable
                dana protection law.
            </p>
        </div>
    </div>

    <div class="row justify-content-center pt-5">
        <div class="col-sm-10">
            <h3>INQUIRIES AND COMPLAINTS</h3>
            <p>
                If you have any questions relating to the handling of your
                personal information or want to exercise your rights set out
                above, please contact us by email info@beyondi.co. If you want
                to make a complaint about the way we have processed your
                personal data, you can contact the national statutory data
                protection authority.
            </p>
        </div>
    </div>

    <div class="row justify-content-center pt-5">
        <div class="col-sm-10">
            <h3>CHANGES TO THE PRIVACY NOTICE</h3>
            <p>
                Beyondi reserves the right to update this Notice at any time by
                publishing the changes on this website and they become effective
                from the moment of posting them on the website. If you continue
                to use Beyondi website or otherwise communicate with us after
                those changes are in effect, that will constitute your
                acceptance of those changes - please check back regularly to
                ensure you remain up to date
            </p>
        </div>
    </div>
</div>
